const translations = {
  en: {
    title: 'Current Month Withdrawals',
    processor: 'Processor',
    amount: 'Amount',
    status: 'Status',
    transactionId: 'TransactionID',
    completion: 'Completion',
    back: 'BACK',
    withdrawalHistoryNotice: 'Withdrawal history notice',
    withdrawalCancelNotice: 'Withdrawal cancel notice',
    withdrawal: 'Withdrawal',
  },
  es: {
    title: 'Retiros del Mes Actual',
    processor: 'Procesador',
    amount: 'Monto',
    status: 'Estado',
    transactionId: 'ID de Transacción',
    completion: 'Avance',
    back: 'ATRÁS',
    withdrawalHistoryNotice: 'Aviso de historial de retiros',
    withdrawalCancelNotice: 'Aviso de cancelación de retiro',
    withdrawal: 'Retiro',
  },
  pt: {
    title: 'Saques do Mês Atual',
    processor: 'Processador',
    amount: 'Valor',
    status: 'Status',
    transactionId: 'ID da Transação',
    completion: 'Progresso',
    back: 'VOLTAR',
    withdrawalHistoryNotice: 'Aviso de histórico de saques',
    withdrawalCancelNotice: 'Aviso de cancelamento de saque',
    withdrawal: 'Saque',
  },
}

export default translations
